'use strict';

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events');

var pull = require('pull-stream');

var Pushable = require('pull-pushable');

var PROTOCOL = require('./protocol');

var encoding = require('./encoding');

var getPeerId = require('./peer-id');

module.exports =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Connection, _EventEmitter);

  function Connection(id, ipfs, room) {
    var _this;

    _classCallCheck(this, Connection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Connection).call(this));
    _this._id = id;
    _this._ipfs = ipfs;
    _this._room = room;
    _this._connection = null;
    _this._connecting = false;
    return _this;
  }

  _createClass(Connection, [{
    key: "push",
    value: function push(message) {
      var _this2 = this;

      if (this._connection) {
        this._connection.push(encoding(message));
      } else {
        this.once('connect', function () {
          return _this2.push(message);
        });

        if (!this._connecting) {
          this._getConnection();
        }
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this._connection) {
        this._connection.end();
      }
    }
  }, {
    key: "_getConnection",
    value: function _getConnection() {
      var _this3 = this;

      this._connecting = true;

      this._getPeerAddresses(this._id, function (err, peerAddresses) {
        if (err) {
          _this3.emit('error', err);

          return; // early
        }

        if (!peerAddresses.length) {
          _this3.emit('disconnect');

          return; // early
        }

        _this3._ipfs._libp2pNode.dialProtocol(peerAddresses[0], PROTOCOL, function (err, conn) {
          if (err) {
            _this3.emit('disconnect');

            return; // early
          }

          _this3._connecting = false;
          var pushable = Pushable();
          _this3._connection = pushable;
          pull(pushable, conn, pull.onEnd(function () {
            delete _this3._connection;

            _this3.emit('disconnect');
          }));

          _this3.emit('connect', pushable);
        });
      });
    }
  }, {
    key: "_getPeerAddresses",
    value: function _getPeerAddresses(peerId, callback) {
      this._ipfs.swarm.peers(function (err, peersAddresses) {
        if (err) {
          callback(err);
          return; // early
        }

        callback(null, peersAddresses.filter(function (peerAddress) {
          return getPeerId(peerAddress.peer) === peerId;
        }).map(function (peerAddress) {
          return peerAddress.peer;
        }));
      });
    }
  }]);

  return Connection;
}(EventEmitter);